import axios from 'axios';

export const GET_IMAGES = "GET_IMAGES";

const url = 'https://0g7yiryotl.execute-api.us-east-1.amazonaws.com/prod/image'

export const getImagesFromApi = () => {
    return async (dispatch) => {
        try {
            const request = await axios.get(url)
            dispatch({
                type: GET_IMAGES,
                payload: request.data
            })
        } catch (error) {
            dispatch({
                type: GET_IMAGES,
                payload: {images:false, styles:false}
            })
            console.log(error)
        }
    }
}
